import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { memo } from 'react'

import IconSearch from '@/components/base/IconSearch'
import useTrans from '@/hooks/useTrans'

import TopCoinsTableDesktop from './desktop'
import TopCoinsListMobile from './mobile'
import { StyledInput } from './styles'
import { ViewProps } from './types'

const View = ({
  columns,
  isLoading,
  isDesktop,
  searchName,
  topCoinsData,
  methodSelectionRendered,
  onChangeTab,
  setSearchName,
  onClickTokenItem,
}: ViewProps) => {
  const trans = useTrans()
  const computedCommonProps = {
    columns,
    isLoading,
    topCoinsData,
    onClickTokenItem,
  }

  return (
    <Stack gap="16px">
      {/* Top Coins Tabs + Input Search */}
      <Stack className="md:flex-row items-center" gap="12px" justifyContent="space-between">
        {/* Top Coins Tabs */}
        <Stack
          direction="row"
          className="w-full md:w-auto rounded-lg p-[6.5px] bg-[#121823]/[0.32]"
          gap="12px"
        >
          <Button
            className="uppercase p-[8px] text-xs text-[#C2CBD9] rounded-[4px] flex-1 md:min-w-[140px] font-semibold !opacity-100 !bg-[#1E2735]"
            onClick={() => onChangeTab('spot')}
          >
            {trans.core_tokens_list.spot}
          </Button>
        </Stack>

        {/* Top Coins Input Search */}
        <StyledInput
          fullWidth={false}
          disableUnderline
          placeholder={trans.core_tokens_list.search_name_placeholder}
          startAdornment={<IconSearch width={20} color="#9CA3AE" />}
          className="w-full md:w-[343px] max-w-full"
          value={searchName}
          onChange={(evt) => setSearchName(evt.target.value)}
          data-testid="top-coins-search"
        />
      </Stack>

      {isDesktop ? (
        <TopCoinsTableDesktop {...computedCommonProps} />
      ) : (
        <TopCoinsListMobile {...computedCommonProps} />
      )}

      {methodSelectionRendered}
    </Stack>
  )
}

export default memo(View)
